let _abda = false;

export function setAbdaMode(v: boolean) { 
  _abda = !!v; 
  if (import.meta.env.MODE !== 'production') {
    console.debug('[ABDA Runtime] Mode set to:', _abda);
  }
}

export function isAbdaMode() { 
  return _abda; 
}

export const BLOCKED_WS = ["/editor", "/chat", "/abda"]; // expand as needed
